var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "embed-responsive" },
    [
      _c("span", { staticClass: "d-block", style: _vm.ratioStyle }),
      _vm._v(" "),
      _vm._t("item", null, null, { itemClass: _vm.itemClass })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }